import actions from '../actions/cancellationPolicyActions';

import createReducer from '../utils/createReducer';

// see graphql-traveler-cancellation type LodgingCancellationPolicy
export const initialState = {
    cancellationPolicyLabel: {
        label: '',
        isFullRefundWindow: false
    },
    undatedPolicyText: '',
    cancellationPolicyPeriods: [],
    cancellationTimelinePeriods: [],
    unstructuredPolicyFreeText: null,
    failedOnQuoteLoad: false
};

const actionHandlers = {
    [actions.UPDATE_CANCELLATION_POLICY](_, {payload = {}}) {
        const {cancellationPolicy} = payload;
        return {...initialState, ...cancellationPolicy};
    },

    [actions.FAILED_QUOTE_CANCELLATION_POLICY_LOAD](_, {payload}) {
        const {failedOnQuoteLoad} = payload;
        return {...initialState, failedOnQuoteLoad};
    }
};

export default createReducer(actionHandlers, initialState);
